/*
 * Copyright (c) 2023. Collabro Limited
 */
import React from "react";
import { DateTime } from "luxon";
import { DisplayController, RosterData, Total, Traffic } from "RosterData";
import { Location } from "SearchParameters";
import AuthenticatedContextProvider from "./AuthenticatedContext";
import SearchParameters from "../SearchParameters/SearchParameters";
import DashboardContainer from "../DashboardContainer/DashboardContainer";
import { AxiosError } from "axios";
import Header from "../Header/Header";
import { VantageUser } from "../../interface/credentials";
import { FilterProps } from "../Filter/FilterInput";
import { SortProps } from "../Sort/SortScreen";

interface AuthenticatedProps {
  loggedInUser: VantageUser;
  setLoggedInUser: any;
  setLogout: any;
  logout: any;
}

export interface AuthenticatedContextProps {
  colorMode: any;
  initialFilters: FilterProps[];
  setInitialFilters: any;
  displayController: DisplayController | null;
  setDisplayController: any;
  initialSorting: SortProps[];
  setInitialSorting: any;
  getLatestUserPreferences: any;
  getLatestReportData: any;
  endDate: DateTime | null;
  setEndDate: any;
  locationOptions: Location[] | undefined;
  interval: DateTime[] | null;
  handleNewInterval: any;
  reportDataLoading: boolean;
  reportDataFetching: boolean;
  reportDataError: boolean;
  reportDataErrorMessage: AxiosError | null;
  reportData: RosterData[] | null;
  totals: Total[] | null;
  trafficData: Traffic[] | null;
  loggedInUser: VantageUser | null;
  setLoggedInUser: any;
  currentLocation: Location | null;
  setCurrentLocation: any;
  tableLoading: boolean;
  setTableLoading: any;
  sendUserFeedback: any;
  handleError: any;
  searchQuery: string;
  setSearchQuery: any;
  initialLayers: string[];
  setInitialLayers: any;
}

export const AuthenticatedContext =
  React.createContext<AuthenticatedContextProps>({
    colorMode: null,
    initialFilters: [],
    setInitialFilters: null,
    displayController: null,
    setDisplayController: null,
    initialSorting: [],
    setInitialSorting: null,
    getLatestUserPreferences: null,
    getLatestReportData: null,
    endDate: null,
    setEndDate: null,
    locationOptions: undefined,
    interval: null,
    handleNewInterval: null,
    reportDataLoading: true,
    reportDataFetching: true,
    reportDataError: false,
    reportDataErrorMessage: null,
    reportData: null,
    totals: null,
    trafficData: null,
    loggedInUser: null,
    setLoggedInUser: null,
    currentLocation: null,
    setCurrentLocation: null,
    tableLoading: false,
    setTableLoading: null,
    sendUserFeedback: null,
    handleError: null,
    searchQuery: "",
    setSearchQuery: null,
    initialLayers: [],
    setInitialLayers: null,
  });

const Authenticated = (props: AuthenticatedProps) => {
  return (
    <AuthenticatedContextProvider
      loggedInUser={props.loggedInUser}
      setLoggedInUser={props.setLoggedInUser}
      setLogout={props.setLogout}
    >
      <>
        <Header logout={props.logout} setLogout={props.setLogout} />
        <SearchParameters />
        <DashboardContainer />
      </>
    </AuthenticatedContextProvider>
  );
};

export default Authenticated;
